import { CommonUtils } from "../../../util/common-utils";

export interface SearchMenuCategorySelection {
    categories?: number[];
}

export interface SearchMenuCategoryItem {
    category_id?: number;
    category_name?: string;
}

export class SearchMenuCategoryUtils {
    public selectedCategories: number[];

    public constructor() {
        this.selectedCategories = [];
    }

    public updateSelection(selection: SearchMenuCategorySelection): void {
        this.selectedCategories = selection.categories || [];
    }

    public getSelection(): { categories: number[] } {
        return {
            categories: this.selectedCategories,
        };
    }

    public hasSelection(): boolean {
        return this.selectedCategories.length > 0;
    }

    public executeSearch(query = ""): void {
        if (!this.hasSelection() && !query) {
            console.warn("[SearchMenuCategoryUtils] No selection or query to search");
            return;
        }

        const url = this.buildSearchUrl(query);
        window.location.href = CommonUtils.resolveUrl(url);
    }

    public buildSearchUrl(query = ""): string {
        const params = new URLSearchParams();

        const q = query.trim();
        if (q !== "") {
            params.set("search", q);
        }

        if (this.selectedCategories.length > 0) {
            params.set("category_id", this.selectedCategories.join(","));
        }

        const queryString = params.toString();
        return queryString ? `/products?${queryString}` : "/products";
    }

    public clearSelection(): void {
        this.selectedCategories = [];
    }

    public getSelectedCategoryNames(categories: SearchMenuCategoryItem[]): string[] {
        const names: string[] = [];
        const allCategories = Array.isArray(categories) ? categories : [];

        this.selectedCategories.forEach((id) => {
            const category = allCategories.find((item) => item.category_id === id);
            if (category && category.category_name) {
                names.push(category.category_name);
            }
        });

        return names;
    }

    public toggleCategory(categoryId: number): void {
        const index = this.selectedCategories.indexOf(categoryId);

        if (index > -1) {
            this.selectedCategories.splice(index, 1);
            return;
        }

        this.selectedCategories.push(categoryId);
    }

    public isCategorySelected(categoryId: number): boolean {
        return this.selectedCategories.includes(categoryId);
    }
}
